import {Component, HostBinding, NgZone, OnDestroy, OnInit, Optional, ViewChild} from '@angular/core';
import {ChartComponent} from 'ng-apexcharts';
import {
	TrendsComparisonCardDirective,
	TrendsComparisonChartPayload,
	TrendsComparisonDeltaItem
} from "../trendsComparisonCard/trends-comparison-card.directive";

@Component({
	selector: 'trends-comparison-chart',
	templateUrl: './trends-comparison-chart.component.html',
	styleUrls: ['./trends-comparison-chart.component.scss']
})
export class TrendsComparisonChartComponent implements OnInit, OnDestroy {
	payload: TrendsComparisonChartPayload = null;
	loading = false;

	@ViewChild('comparedChart') comparedChart: ChartComponent;

	@HostBinding('class.has-payload')
	get hasPayload() {
		return !!this.payload;
	}

	constructor(@Optional() private card: TrendsComparisonCardDirective,
				private ngZone: NgZone) {
	}

	ngOnInit() {
		this.card?.setRenderer(this);
	}

	ngOnDestroy() {
		if (this.card) {
			this.card.setRenderer(null);
		}
	}

	setPayload(payload: TrendsComparisonChartPayload) {
		this.payload = payload;
		this.loading = !!payload?.loading;
		// force ApexCharts to re-render the right chart after Angular CD has processed the new payload;
		// ng-apexcharts does not always update an existing chart instance when bound inputs change
		if (payload?.comparedOptions?.series?.length && !this.loading) {
			const seriesSnapshot = payload.comparedOptions.series;
			this.ngZone.runOutsideAngular(() => {
				setTimeout(() => {
					if (!this.comparedChart) {
						return;
					}
					this.ngZone.run(() => {
						this.comparedChart.updateOptions({series: seriesSnapshot}, false, false);
					});
				}, 50);
			});
		}
	}

	setLoading(loading: boolean) {
		this.loading = loading;
		if (this.payload) {
			this.payload.loading = loading;
		}
	}

	clear() {
		this.payload = null;
		this.loading = false;
	}

	trackDelta(index: number, item: TrendsComparisonDeltaItem) {
		return item?.label || index;
	}

	getDeltaIcon(delta: TrendsComparisonDeltaItem) {
		if (!delta?.change) {
			return 'fa-minus';
		}
		return delta.change > 0 ? 'fa-arrow-up' : 'fa-arrow-down';
	}

	getDeltaClass(delta: TrendsComparisonDeltaItem) {
		if (!delta?.change || delta.polarity === 'neutral') {
			return 'neutral';
		}
		const isIncrease = delta.change > 0;
		if (delta.polarity === 'positive') {
			return isIncrease ? 'positive' : 'negative';
		}
		return isIncrease ? 'negative' : 'positive';
	}

	formatChange(delta: TrendsComparisonDeltaItem) {
		const change = Math.abs(delta?.change || 0);
		return `${change.toFixed(1)}%`;
	}

	formatDiff(delta: TrendsComparisonDeltaItem) {
		if (delta?.diff == null || isNaN(delta.diff as any)) {
			return '';
		}
		const diff = Math.round(delta.diff);
		return ` (${diff > 0 ? '+' : ''}${diff})`;
	}
}
